<app-header-one></app-header-one>

<div class="page-title-area page-title-bg1">
    <div class="container">
        <div class="page-title-content">
            <h2>{{ "Request Booking" | translate }}</h2>
        </div>
    </div>
</div>

<section class="contact-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="contact-form">
                    <h3>
                        {{ "Drop Us your personal information" | translate }}
                    </h3>
                    <p>
                        {{
                            "Please fill out the form below and one of our Customer
                        Experience experts will contact you"
                                | translate
                        }}
                    </p>
                    <form id="bookingForm" #bookingForm="ngForm">
                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <mat-checkbox
                                        class="example-margin"
                                        [(ngModel)]="sameUser"
                                        [(indeterminate)]="indeterminate"
                                        color="primary"
                                        name="txtSameUser"
                                    >
                                        {{ "Booking for me" | translate }}
                                    </mat-checkbox>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6" *ngIf="!sameUser">
                                <div class="form-group mb-3">
                                    <label
                                        >{{ "Email" | translate }}
                                        <span>*</span></label
                                    >
                                    <input
                                        type="text"
                                        name="txtEmail"
                                        id="txtEmail"
                                        required
                                        class="form-control"
                                        [(ngModel)]="booking.email"
                                        [placeholder]="'Email' | translate"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6" *ngIf="!sameUser">
                                <div class="form-group mb-3">
                                    <label
                                        >{{ "Patient Name" | translate }}
                                        <span>*</span></label
                                    >
                                    <input
                                        type="text"
                                        name="txtPatientName"
                                        id="txtPatientName"
                                        required
                                        class="form-control"
                                        [(ngModel)]="booking.name"
                                        [placeholder]="
                                            'Patient Name' | translate
                                        "
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6" *ngIf="!sameUser">
                                <div class="form-group mb-3">
                                    <label
                                        >{{ "Patient Nation" | translate }}
                                        <span>*</span></label
                                    >
                                    <input
                                        type="text"
                                        name="txtNation"
                                        id="txtNation"
                                        required
                                        [(ngModel)]="booking.nation"
                                        class="form-control"
                                        [placeholder]="
                                            'Patient Nation' | translate
                                        "
                                    />
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6" *ngIf="!sameUser">
                                <div class="form-group mb-3">
                                    <label
                                        >{{
                                            "Patient Phone Number" | translate
                                        }}
                                        <span>*</span></label
                                    >
                                    <input
                                        type="text"
                                        name="txtPhoneNumber"
                                        id="txtPhoneNumber"
                                        required
                                        [(ngModel)]="booking.mobile"
                                        class="form-control"
                                        [placeholder]="
                                            'Patient Phone Number' | translate
                                        "
                                    />
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6" *ngIf="!sameUser">
                                <div class="form-group mb-3">
                                    <mat-form-field>
                                        <input
                                            matInput
                                            [matDatepicker]="pickerEnd"
                                            name="txtDateOfBirth"
                                            [(ngModel)]="dateOfBirth"
                                            #ngDateOfBirth="ngModel"
                                            [placeholder]="
                                                'MM/DD/YYYY' | translate
                                            "
                                            class="form-control birthdate"
                                        />
                                        <input type="hidden" />
                                        <mat-datepicker-toggle
                                            matSuffix
                                            [for]="pickerEnd"
                                        ></mat-datepicker-toggle>
                                        <mat-datepicker
                                            #pickerEnd
                                        ></mat-datepicker>
                                        <mat-error
                                            *ngIf="
                                                ngDateOfBirth.touched &&
                                                !ngDateOfBirth.valid
                                            "
                                        >
                                            Please fill this field
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3" *ngIf="!sameUser">
                                <mat-form-field
                                    appearance="fill"
                                    class="gender-dropdown"
                                >
                                    <mat-label>Select an option</mat-label>
                                    <mat-select
                                        [(value)]="booking.gender"
                                        required
                                        class="birthdate"
                                    >
                                        <mat-option value="male">{{
                                            "Male" | translate
                                        }}</mat-option>
                                        <mat-option value="female">{{
                                            "Female" | translate
                                        }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <label
                                        >{{ "ID Photo" | translate }}
                                        <span>*</span></label
                                    >

                                    <input
                                        class="form-control inp-file"
                                        type="file"
                                        name="txtIDPhoto"
                                        id="txtIDPhoto"
                                        (change)="onChangeIDPhoto($event)"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <label
                                        >{{ "Medical Report" | translate }}
                                        <span>*</span></label
                                    >

                                    <input
                                        class="form-control inp-file"
                                        type="file"
                                        name="txtMedicalReport"
                                        id="txtMedicalReport"
                                        (change)="onChangeMedicalReport($event)"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <label
                                        >{{ "Radiology" | translate }} (zip)
                                        <span>*</span></label
                                    >

                                    <input
                                        class="form-control inp-file"
                                        type="file"
                                        name="txtRadiology"
                                        id="txtRadiology"
                                        (change)="onChangeRadiology($event)"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <label
                                        >{{ "Retina" | translate }}
                                        <span>*</span></label
                                    >

                                    <input
                                        class="form-control inp-file"
                                        type="file"
                                        name="txtRetina"
                                        id="txtRetina"
                                        (change)="onChangeRetina($event)"
                                    />
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <label
                                        >{{ "Your Message" | translate }}
                                        <span>*</span></label
                                    >
                                    <textarea
                                        name="message"
                                        id="message"
                                        cols="30"
                                        rows="5"
                                        [(ngModel)]="booking.description"
                                        required
                                        class="form-control message"
                                        [placeholder]="
                                            'Your Message' | translate
                                        "
                                    ></textarea>
                                    <!-- <p>yyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy</p> -->
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 text-center">
                                <button
                                    type="submit"
                                    class="default-btn"
                                    (click)="requestBooking()"
                                >
                                    {{ "Book" | translate }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <div id="map">
    <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2987.759347356707!2d-73.78797548425361!3d41.50948959637902!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89dd490255c9bfa7%3A0xfe099945f43b6e47!2sWonderland%20Dr%2C%20East%20Fishkill%2C%20NY%2012533%2C%20USA!5e0!3m2!1sen!2sbd!4v1587654262668!5m2!1sen!2sbd"
    ></iframe>
</div> -->
